import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SessionContext } from './SessionContext'
import { LIBRARIAN_TYPES } from 'src/constants'
import { actions as userRoleActions } from 'src/features/userRole/UserRoleSlice'

const getSessionProviderValue = session => {
  return {
    ...session,
    userIsAuthenticated: () => session.checked && session.authenticated,
    userHasLicense: license =>
      session.checked &&
      session.authenticated &&
      session.user.license === license,
    getInterests: () =>
      session?.user?.interests ? session.user.interests.stated : null,
    getUserPartyId: () => session?.user?.party_id,
    getUserLicenseTypes: () =>
      session?.user?.license_types?.map(license => license.name),
    userIsLibrarian: () => {
      const licenseNames = session?.user?.license_types?.map(l => l.name) || []
      return [LIBRARIAN_TYPES.ADMIN, LIBRARIAN_TYPES.USER].some(type =>
        licenseNames.includes(type)
      )
    },
    userIsLibraryAdmin: () => {
      return session?.user?.license_types
        ?.map(license => license.name)
        .includes(LIBRARIAN_TYPES.ADMIN)
    },
    getDerivedCompany: () => session?.user?.derived_company
  }
}

export const SessionProvider = ({ children }) => {
  const session = useSelector(state => state.session)
  const dispatch = useDispatch()

  useEffect(() => {
    const license = session?.user?.license ?? null
    dispatch(userRoleActions.setLicense(license))
  }, [session?.user?.license, dispatch])

  return (
    <SessionContext.Provider value={getSessionProviderValue(session)}>
      {children}
    </SessionContext.Provider>
  )
}

export default SessionProvider
